import { render, staticRenderFns } from "./FlyersSizeContributionPieChart.vue?vue&type=template&id=3d277442"
import script from "./FlyersSizeContributionPieChart.vue?vue&type=script&lang=js"
export * from "./FlyersSizeContributionPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports